import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import fire from '../../../firebase';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  TextField,
  Snackbar
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';


const AccountDetails = props => {

  const useStyles = makeStyles(() => ({
    root: {}
  }));
  const { className, ...rest } = props;
  const { user } = props;

  const classes = useStyles();
  const [alertState, setAlert] = useState(false)
  const [values, setValues] = useState({
    firstName: user.first_name,
    lastName: user.last_name,
    email: user.email
  });

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlert(false)
  };

  const saveDetails = (event) =>{
    event.preventDefault()
    if(values.email !== user.email){
      console.log(fire.auth().currentUser)
      fire.auth().currentUser.updateEmail(values.email)
        .then(() => {
          alert('Your email has been changed.')
        })
        .catch((msg)=>{
          alert(msg)
        });
    }
    let new_data = Object.assign({},user)
    delete new_data['user']
    delete new_data['sub_info']
    delete new_data['sub_status']
    delete new_data['sub_details']
    new_data['first_name'] = values.firstName
    new_data['last_name'] = values.lastName
    fire.database().ref('/users/'+user['uid']).set(new_data)
    setAlert(true)
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <form
        autoComplete="off"
        noValidate
        onSubmit={saveDetails}
      >
        <CardHeader
          subheader="The information can be edited"
          title="Profile"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the first name"
                label="First name"
                margin="dense"
                name="firstName"
                onChange={handleChange}
                required
                value={values.firstName}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Last name"
                margin="dense"
                name="lastName"
                onChange={handleChange}
                required
                value={values.lastName}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                fullWidth
                label="Email Address"
                margin="dense"
                name="email"
                onChange={handleChange}
                required
                value={values.email}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Save details
          </Button>
        </CardActions>
      </form>
      <Snackbar 
        open={alertState}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert
          severity="success">
          Your changes have been saved.
        </Alert>
      </Snackbar>
    </Card>
  );
};

AccountDetails.propTypes = {
  className: PropTypes.string
};

export default AccountDetails;
